import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import loading from "../Dashboard/assets/img/loading.gif"
import AdminLayout from "../UI/Layout/AdminLayout";
import { getUserPriceList, NODE_HOST_URL } from "../Dashboard/api/Api";
import Axios from "../../axios/Axios";
class ResellerBillingHistory extends Component {
  constructor() {
    const lStorage =
      JSON.parse(localStorage.getItem("admin")) ||
      JSON.parse(localStorage.getItem("emp")) ||
      JSON.parse(localStorage.getItem("reseller"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;

    super();

    this.fileNames = {
      csv: "priceList.csv",
    };

    this.state = {
      user_id: userId,
      token: userToken,
      emailCost: "",
      serchData: "",
      fileType: "csv",
      fileDownloadUrl: null,
      priceListData: null,
      successMessage: false,
      errorMessage: "",
      bgColor: "alert alert-success alert-dismissible",
      channel: "whatsapp",
      voiceCost: 0,
      voicePulse: 0,
      rcsSearchData: [],
      loading: false

    };
  }

  componentDidMount() {
    this.SearchDataOnLoad();
    this.rcsData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.channel !== this.state.channel) {
      this.SearchDataOnLoad();
      this.rcsData();
    }
  }

  SearchDataOnLoad() {
    this.setState({ loading: true })
    let paramData = {
      user_id: this.state.user_id,
      method: "retrieve",
      token: this.state.token,
      keyword: ""
    }
    getUserPriceList(paramData).then((result) => {
      if (result.data.success === true) {
        let filterData = []
        if (this.state.channel === "whatsapp") {
          filterData = result.data.data.filter(x => x.wp_auth_cost !== 0 || x.wp_conv_cost !== 0 || x.wp_sending_cost !== 0 || x.wp_util_cost !== 0)
        }
        else if (this.state.channel === "sms") {
          filterData = result.data.data.filter(x => x.sms_cost !== 0)
        }
        else if (this.state.channel === "voice") {
          let filterVoiceData = result.data.data.filter(x => x.country_code === 91)
          this.setState({ voiceCost: filterVoiceData[0].voice_cost, voicePulse: filterVoiceData[0].voice_pulse })
        }
        else {
          filterData = result.data.data
        }
        this.setState({ priceListData: filterData });
        this.setState({ emailCost: result.data.email_cost });
      } else {
        this.setState({
          successMessage: true,
          successBg: "alert alert-danger alert-dismissible",
          errorMessage: result.data.message,
        });
      }
    });
    this.setState({ loading: false })
  }

  rcsData = async () => {
    this.setState({ loading: true })
    let paramData = {
      user_id: this.state.user_id,
      token: this.state.token,
      method: "retrieve_price_personal"
    }
    try {
      let { data } = await Axios.post(`${NODE_HOST_URL}/rcs_setting`, paramData)
      if (data.success) {
        this.setState({ rcsSearchData: data.data })
      }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false })
  }

  searchUser() {
    this.setState({ loading: true })
    if (this.state.serchData === "") {
      this.SearchDataOnLoad();
      this.setState({
        successMessage: true,
        errorMessage: "Enter User Name",
        bgColor: "alert alert-danger alert-dismissible",
      });
    } else {
      let paramData = {
        user_id: this.state.user_id,
        method: "search",
        token: this.state.token,
        keyword: this.state.serchData
      }
      getUserPriceList(paramData).then((result) => {
        if (result.data.success === true) {
          this.setState({
            bgColor: "alert alert-success alert-dismissible",
            errorMessage: "Data Updated",
          });
          let filterSearchData = []
          if (this.state.channel === "whatsapp") {
            filterSearchData = result.data.data.filter(x => x.wp_auth_cost !== 0 || x.wp_conv_cost !== 0 || x.wp_sending_cost !== 0 || x.wp_util_cost !== 0)
          }
          else if (this.state.channel === "sms") {
            filterSearchData = result.data.data.filter(x => x.sms_cost !== 0)
          }
          this.setState({ priceListData: filterSearchData });
          this.setState({ emailCost: result.data.email_cost });
        } else {
          this.setState({
            successMessage: true,
            successBg: "alert alert-danger alert-dismissible",
            errorMessage: result.data.message,
          });
        }
      });
    }
    this.setState({ loading: false })
  }

  handleChannelChange = (e) => {
    this.setState({ channel: e.target.value })

    if (e.target.value == "email" || e.target.value == "voice") {
      this.setState({ serchData: '' })
    }
  }

  render() {
    return (
      <AdminLayout>

        <main className="content">
          <div className="container-fluid p-0">
            <div className=" row mb-2 mb-xl-3">
              <div className="col-auto d-none d-sm-block">
                <h3>
                  <strong> My Price </strong> List{" "}
                </h3>
              </div>
            </div>

            {this.state.successMessage ? (
              <div className={this.state.bgColor} role="alert">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div className="">{this.state.errorMessage}</div>
              </div>
            ) : null}

            <div className="card flex-fill">
              <div className="card-body">
                <h6 className="card-subtitle text-muted">Filter </h6>

                <div className="row">
                  <div className="col-md-6">
                    <div className="input-group mb-2 mr-sm-2">
                      <div className="input-group-text">
                        <FontAwesomeIcon icon={faSearch} />
                      </div>
                      <input
                        type="text"
                        value={this.state.serchData}
                        disabled={this.state.channel === "email" || this.state.channel === "voice" ? true : false}
                        onChange={(event) => {
                          this.setState({
                            serchData: event.target.value,
                          });
                        }}
                        placeholder="Enter Country Code or Country Name"
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-md-3 text-right">
                    <div className="input-group mb-2 mr-sm-2">
                      <button
                        onClick={() => this.searchUser()}
                        className="btn btn-sm btn-primary btn-block"
                        disabled={this.state.channel === "email" || this.state.channel === "voice" ? true : false}
                      >
                        {" "}
                        <FontAwesomeIcon icon={faSearch} /> Search{" "}
                      </button>
                    </div>
                  </div>

                  <div className="col-md-3 text-right">
                    <select className="form-control" value={this.state.channel} onChange={this.handleChannelChange}>
                      <option value="whatsapp">Whatsapp</option>
                      <option value="sms">SMS</option>
                      <option value="voice">Voice</option>
                      <option value="email">Email</option>
                      <option value="rcs">RCS</option>
                    </select>
                  </div>
                </div>

                <a
                  style={{ display: "none" }}
                  download={this.fileNames[this.state.fileType]}
                  href={this.state.fileDownloadUrl}
                  ref={(e) => (this.dofileDownload = e)}
                >
                  {" "}
                  download it{" "}
                </a>

                {this.state.priceListData ? (
                  <div
                    style={{ height: 400 + "px" }}
                    className="table-responsive  mt-3"
                  >
                    <table className="table table-hover my-0">
                      <thead>
                        <tr>
                          {this.state.channel !== "email" && <th className="d-xl-table-cell">Country</th>}
                          {this.state.channel === "sms" && <th className="d-xl-table-cell">
                            Currency / SMS Cost
                          </th>}
                          {this.state.channel === "whatsapp" &&
                            <>
                              <th className="d-xl-table-cell">conv cost</th>
                              <th className="d-xl-table-cell">sending cost</th>
                              <th className="d-xl-table-cell">Authentication cost</th>
                              <th className="d-xl-table-cell">Utility cost</th>
                            </>}
                          {this.state.channel === "voice" ?
                            <>
                              <th className="d-xl-table-cell">Voice Cost</th>
                              <th>Voice Pulse</th>
                            </> : null}
                          {this.state.channel === "email" && <th>Email Cost</th>}
                          {this.state.channel === "rcs" &&
                            <>
                              <th>A2P Single Cost</th>
                              <th>A2P Conversation Cost</th>
                              <th>P2A Conversation Cost</th>
                              <th>Basic Cost</th>
                            </>
                          }
                        </tr>
                      </thead>
                      {this.state.channel === "whatsapp" || this.state.channel === "sms" ?
                        <tbody>
                          {this.state.priceListData.map((item, i) => (
                            <tr>
                              {this.state.channel !== "email" &&
                                <td>
                                  {item.country_name} ({item.country_code})
                                </td>}
                              {this.state.channel === "sms" &&
                                <td>
                                  {item.currency} :{" "}
                                  {parseFloat(item.sms_cost).toFixed(6)}
                                </td>}
                              {this.state.channel === "whatsapp" &&
                                <>
                                  <td>{item.currency} :{" "}{item.wp_conv_cost}</td>
                                  <td>{item.currency} :{" "}{item.wp_sending_cost}</td>
                                  <td>{item.currency} :{" "}{item.wp_auth_cost}</td>
                                  <td>{item.currency} :{" "}{item.wp_util_cost}</td>
                                </>}
                            </tr>
                          ))}
                        </tbody> :
                        null}

                      {this.state.channel === "email" &&
                        <tbody>
                          <tr>
                            <td>
                              INR :{" "}
                              {parseFloat(this.state.emailCost).toFixed(3)}
                            </td>
                          </tr>
                        </tbody>}

                      {this.state.channel === "voice" &&
                        <tbody>
                          <tr>
                            <td>India(91)</td>
                            <td>
                              INR :{" "}
                              {parseFloat(this.state.voiceCost).toFixed(3)}
                            </td>
                            <td>{this.state.voicePulse} Sec</td>
                          </tr>
                        </tbody>}

                      {this.state.channel === "rcs" &&
                        <tbody>
                          {this.state.rcsSearchData.map((x) => {
                            return (
                              <tr>
                                <td>India({x.country_code})</td>
                                <td>INR :{" "}{x.a2p_single_sms_cost}</td>
                                <td>INR :{" "}{x.a2p_conv_cost}</td>
                                <td>INR :{" "}{x.p2a_conv_cost}</td>
                                <td>INR :{" "}{x.basic_sms_cost}</td>
                              </tr>
                            )
                          })}
                        </tbody>}
                    </table>
                  </div>
                ) : this.state.loading ? (
                  <div className="text-center">
                    <div className="card-body">
                      <img
                        alt="Empty Data"
                        style={{ width: 100 + "px" }}
                        className="project-empty-img"
                        src={loading}
                      />
                      <p>Loading...... </p>
                    </div>
                  </div>
                ) :
                  <div className="text-center">
                    <div className="card-body">
                      <p>Service Not Active Please contact your Account Manager ... </p>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </main>
      </AdminLayout>



    );
  }
}

export default ResellerBillingHistory;